<p-dialog
  [modal]="true"
  [showHeader]="false"
  [(visible)]="visible"
  [closable]="false"
  [blockScroll]="true"
  [baseZIndex]="10000"
  [resizable]="false"
  [maximizable]="true"
  [draggable]="false"
  appendTo="body"
  styleClass="shared-experiment-dialog"
>
  <ng-template pTemplate="content">
    <div class="contanier dialog-container">
      <div class="dialog-header-row">
        <span class="invite-text">{{
          selectedExperiment?.experiment_type !== "folder"
            ? ("PRODUCT_HEADER.SHARE_EXPERIMENT" | translate)
            : ("SHARED.SHARE_FOLDER" | translate)
        }}</span>
        <div class="share-experiment-wrapper">
          <span (click)="closeDialog()">
            <img src="https://cdn.catexpert.ab-inbev.com/assets/images/close-dialog.svg" />
          </span>
        </div>
      </div>
      <div class="dialog-content-row">
        <div class="relative">
          <span class="search-name-icon" *ngIf="!myTextBox.value"
            ><i class="pi pi-search"></i
          ></span>
          <span
            class="close-name-icon cursor-pointer"
            *ngIf="myTextBox.value"
            (click)="validUserList = []"
          >
            <img *ngIf="validUserList.length" src="https://cdn.catexpert.ab-inbev.com/assets/images/autocomplete-cross-icon.svg" />
          </span>
          <p-autoComplete
            [placeholder]="'PRODUCT_HEADER.TYPE_TO_SEARCH_ADD_USER' | translate"
            class="search-box-input"
            styleClass="share-exp-autocomplete"
            [showClear]="false"
            field="name"
            [suggestions]="suggestions"
            (completeMethod)="getUserSuggestions($event)"
            [showEmptyMessage]="true"
            #myTextBox="ngModel"
            multiple
            fluid
            separator=","
            [(ngModel)]="validUserList"
          >
            <ng-template let-data pTemplate="item">
              <div
                class="gap-2 email-list-item"
                [ngClass]="{
                  'disabled-auto-complete-suggestion':
                    isNotFolderType &&
                    !hasMultipleShareAction && !isAllUsersAllowed &&
                    !data.has_key_account_access,
                }"
                (click)="
                  selectedExperiment?.experiment_type === 'folder' ||
                  hasMultipleShareAction ||
                  isAllUsersAllowed ||
                  data.has_key_account_access
                    ? ''
                    : $event.stopPropagation()
                "
              >
                <p class="suggested-name">
                  {{ data.name }}
                </p>
                <p class="suggested-email">{{ data.email }}</p>
                <p
                  *ngIf="
                    isNotFolderType &&
                    !hasMultipleShareAction &&
                    !isAllUsersAllowed &&
                    !data.has_key_account_access
                  "
                  class="suggested-error"
                >
                  {{
                    "PRODUCT_HEADER.USER_LACKS_KEY_ACCOUNT_ACCESS" | translate
                  }}
                </p>
              </div>
            </ng-template>
            <ng-template let-item pTemplate="selectedItem">
              <span class="custom-chip" [ngClass]="{ 'invalid-chip': !item.has_key_account_access }">
                {{ item.name }}
              </span>
            </ng-template>
          </p-autoComplete>
        </div>
        <div class="w-full">
          <div class="w-full button-col">
            <span class="allow-editing">
              <mat-checkbox [(ngModel)]="allowEditing" class="edit-checkbox">
                <span
                  style="
                    font: normal normal 600 12px/17px Open Sans;
                    color: #0a0a0a;
                  "
                >
                  {{ "PRODUCT_HEADER.ALLOW_EDITING" | translate }}</span
                >
              </mat-checkbox>
            </span>
            <button class="share-invite-button" [disabled]="areAllValidUser()" (click)="shareInvite()">
              <span *ngIf="shareLoader" class="loader-align">
                <mat-spinner
                  class="example-margin"
                  color="primary"
                  mode="indeterminate"
                  value="100"
                  strokeWidth="2"
                  diameter="20"
                >
                </mat-spinner>
              </span>
              <span *ngIf="!shareLoader">{{
                "PRODUCT_HEADER.SHARE" | translate
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="sharedWithClicked" class="contanier dialog-container">
      <div class="dialog-content-row mt-4">
        <div class="w-full">
          <span class="invite-text-shared">
            {{ "PRODUCT_HEADER.SHARED_WITH" | translate }}
          </span>
        </div>
      </div>
      <div class="shared-with-wrapper mb-3">
        <div class="shared-list px-3">
          <div
            class="w-full flex shared-users"
            *ngFor="let item of uniqueSharedUsers; let i = index"
          >
            <div class="w-full flex">
              <span
                class="shared-user-name-circle"
                [ngStyle]="{ 'background-color': getColor(i) }"
              >
                {{
                  hasValidValue(item.first_name)
                    ? item.first_name[0] + item.last_name[0]
                    : (item.email[0] | uppercase)
                }}
              </span>
              <span class="shared-user-name">
                <span class="w-full block">
                  {{
                    hasValidValue(item.first_name)
                      ? item.first_name + " " + item.last_name
                      : item.email
                  }}
                </span>
                <span class="shared-user-email w-full block">{{
                  item.email
                }}</span>
              </span>

              <!-- User access for only single experiment and folders -->
              <ng-container *ngIf="!hasMultipleShareAction">
                <div class="remove-div" style="padding-right: 32px">
                  <span
                    class="loader-align"
                    *ngIf="
                      removeShareLoader && item.id === sharedUserIDTobeRemoved
                    "
                  >
                    <mat-spinner
                      class="example-margin"
                      color="primary"
                      mode="indeterminate"
                      value="100"
                      strokeWidth="3"
                      diameter="20"
                    >
                    </mat-spinner>
                  </span>
                </div>
                <span
                  style="
                    font: normal normal 600 10px/14px Open Sans !important;
                    color: #325a6d !important;
                    padding-top: 5px;
                    padding-right: 2px;
                  "
                  *ngIf="item.id !== sharedUserIDTobeRemoved"
                  >Can
                </span>
                <p-dropdown
                  [options]="optionsList"
                  optionLabel="name"
                  optionValue="value"
                  class="edit-user-dropdown"
                  (onChange)="sharedUserActions(item.id, $event, item)"
                  [(ngModel)]="
                    item.permission === 'read' ? 'view' : item.permission
                  "
                  appendTo="body"
                  optionDisabled="inactive"
                  panelStyleClass="edit-user-dropdown-panel"
                  *ngIf="item.id !== sharedUserIDTobeRemoved"
                >
                  <ng-template let-option pTemplate="item">
                    <span
                      [ngClass]="{
                        checkmark: item.permission == option.value,
                        noCheckmark: item.permission != option.value,
                      }"
                    >
                    </span>
                    <span
                      style="
                        padding-left: 4px;
                        color: #325a6d;
                        font: normal normal 600 10px/14px Open Sans;
                      "
                      >{{ option.name }}</span
                    >
                  </ng-template>
                </p-dropdown>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="mt-4" *ngIf="sharedUsers.length === 0">
          <span
            class="validation-msg flex justify-center items-center font-semibold"
            >{{ "PRODUCT_HEADER.NO_SHARED_USER" | translate }}
          </span>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>
